
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiManualOnly as ObiManualOnlyElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-manual-only.js';
 
 
 

 
 export const ObiManualOnly = createComponent({
   react: React,
   tagName: 'obi-manual-only',
   elementClass: ObiManualOnlyElement,
   events: {
     
   }
  });
 
 